/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/** 往来邮件 */
import { http } from '@/services/api/http';
import { RequestOptions } from '@/services/api/types';
import type * as model from './models';

/** 往来邮件 附件下载 */
export async function downloadAttachmentGet(
  payload: {
    attachId?: number;
    composeId?: string;
    mid?: string;
    msgId: string;
    part?: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<void>({
    url: `/gator/api/biz/gator/comms/flows/download`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** 往来邮件 邮件卡片详情 */
export async function emailDetailPost(payload: model.IApiCommsFlowEmailDetailReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultCommsFlowEmailDto>({
    url: `/gator/api/biz/gator/comms/flows/email-card-detail`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** 往来邮件 邮件操作 */
export async function emailOperatePost(payload: model.IApiCommsFlowEmailOperateReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultCommsFlowEmailOperateResp>({
    url: `/gator/api/biz/gator/comms/flows/email-operate`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** 往来邮件 邮件详情 */
export async function writeEmailReadPost(payload: model.IApiCommsFlowEmailDetailReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultCommsEmailDetailResp>({
    url: `/gator/api/biz/gator/comms/flows/email-read`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** 往来邮件 往来邮件列表 */
export async function flowsListPost(payload: model.IApiCommsFlowListParam, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultCommsFlowListResp>({
    url: `/gator/api/biz/gator/comms/flows/list`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** 往来邮件 往来邮件列表 */
export async function flowsListAllPost(payload: model.IApiCommsFlowListAllParam, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultCommsFlowListResp>({
    url: `/gator/api/biz/gator/comms/flows/listAll`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** 往来邮件 标记已读未读 */
export async function markReadPost(payload: model.IApiCommsFlowEmailMarkReadReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultstring>({
    url: `/gator/api/biz/gator/comms/flows/mark-read`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** 往来邮件 陌生人邮件详情 */
export async function strangerEmailReadPost(
  payload: model.IApiCommsFlowStrangerEmailDetailReq,
  options?: RequestOptions
) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultCommsEmailDetailResp>({
    url: `/gator/api/biz/gator/comms/flows/stranger-email-read`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** 往来邮件 陌生人往来邮件列表 */
export async function strangerListPost(payload: model.IApiContactStrangerListParam, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultCommsFlowListResp>({
    url: `/gator/api/biz/gator/comms/flows/stranger-list`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}
